import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import {
    FREQUENCY_OPTIONS,
    getDayOptions,
    TIME_OPTIONS,
} from '@src/utils/scheduling';

const ScheduleFrequencyInput = ({
    frequency = 'monthly',
    frequencyDay,
    day = '1st',
    timeOfDay = '08:00',
    onFrequencyChange,
    onFrequencyDayChange,
    onDayChange,
    onTimeOfDayChange,
    disabled = false,
}) => {
    const currentDay = frequencyDay ?? day;
    const handleDayChange = onFrequencyDayChange || onDayChange;
    const dayOptions = getDayOptions(frequency);

    const handleFrequencyChange = (e) => {
        const newFreq = e.target.value;
        if (onFrequencyChange) {
            onFrequencyChange(newFreq);
        }

        const options = getDayOptions(newFreq);
        if (!options.some((opt) => opt.value === currentDay)) {
            const fallback = options[0]?.value || '';
            if (handleDayChange) {
                handleDayChange(fallback);
            }
        }
    };

    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
                select
                fullWidth
                label="Frequency"
                value={frequency}
                disabled={disabled}
                sx={{ flex: 1 }}
                onChange={handleFrequencyChange}
            >
                {FREQUENCY_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                select
                fullWidth
                label="Day"
                value={currentDay}
                disabled={disabled}
                sx={{ flex: 1 }}
                onChange={(e) => {
                    if (handleDayChange) {
                        handleDayChange(e.target.value);
                    }
                }}
            >
                {dayOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                select
                fullWidth
                label="Time (ET)"
                value={timeOfDay}
                disabled={disabled}
                sx={{ flex: 1 }}
                onChange={(e) => {
                    if (onTimeOfDayChange) {
                        onTimeOfDayChange(e.target.value);
                    }
                }}
            >
                {TIME_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
};

ScheduleFrequencyInput.propTypes = {
    frequency: PropTypes.string,
    frequencyDay: PropTypes.string,
    day: PropTypes.string,
    timeOfDay: PropTypes.string,
    onFrequencyChange: PropTypes.func,
    onFrequencyDayChange: PropTypes.func,
    onDayChange: PropTypes.func,
    onTimeOfDayChange: PropTypes.func,
    disabled: PropTypes.bool,
};

ScheduleFrequencyInput.defaultProps = {
    frequency: 'monthly',
    frequencyDay: undefined,
    day: '1st',
    timeOfDay: '08:00',
    onFrequencyChange: undefined,
    onFrequencyDayChange: undefined,
    onDayChange: undefined,
    onTimeOfDayChange: undefined,
    disabled: false,
};

export default ScheduleFrequencyInput;

